import { Component } from '@theme/component';

/**
 * Expands and collapses the reviews held back behind the "Show more" button.
 *
 * The cards past the cut-off are rendered into the page and hidden with CSS rather
 * than fetched on demand — the whole list is merchant-authored theme blocks, so it
 * is already in the HTML, and hiding it keeps the reviews inside the document for
 * search engines and in-page find.
 *
 * @extends {Component}
 */
class ProductReviewsComponent extends Component {
  requiredRefs = ['list', 'toggle'];

  toggle() {
    const isExpanded = this.dataset.expanded === 'true';
    const nextExpanded = !isExpanded;

    this.dataset.expanded = String(nextExpanded);

    const toggle = this.refs.toggle;
    if (toggle instanceof HTMLElement) {
      toggle.setAttribute('aria-expanded', String(nextExpanded));
      const label = nextExpanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
      if (label) toggle.textContent = label;
    }

    // Collapsing removes everything the reader scrolled past, which would otherwise
    // leave them somewhere further down the page with no idea what moved.
    if (!nextExpanded && this.getBoundingClientRect().top < 0) {
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

if (!customElements.get('product-reviews-component')) {
  customElements.define('product-reviews-component', ProductReviewsComponent);
}
